// v2 cockpit — « Caisse du jour » (owner, 2026-10-22): always TODAY in
// Casablanca, whatever the period. Encaissé auj. · Acomptes auj. · À encaisser
// (open orders with activity in 30 days). Same numbers as the v1 « Argent »
// strip: worker /dashboard/overview → money.today + money.toCollect.
import type { OverviewResponse } from '@/lib/dashboardApi';
import { formatDH } from '@/lib/homeDashboard';
import { useT } from '@/lib/i18n';
import { HomeCard, HomeCardTitle, HEADING_FONT } from './homeParts';

function Cell({ label, value, note, first = false, title }: { label: string; value: string; note: string; first?: boolean; title?: string }) {
  return (
    <div className={`min-w-0 py-0.5 ${first ? 'pr-2.5' : 'px-2.5 border-l border-[#ECE5D6] dark:border-adm-line'}`} title={title}>
      <span className="block text-[11px] text-adm-muted font-medium truncate">{label}</span>
      <b className="block text-[16px] sm:text-[19px] font-medium mt-0.5 text-adm-ink whitespace-nowrap" style={{ fontFamily: HEADING_FONT }}>{value}</b>
      <small className="block text-[10.5px] text-adm-faint leading-[1.3]">{note}</small>
    </div>
  );
}

export function CashBody({ data, days }: { data: OverviewResponse; days: number | null }) {
  const { t } = useT();
  const { today, toCollect } = data.money;
  return (
    <div className="grid grid-cols-3">
      <Cell first label={t('Encaissé auj.')} value={formatDH(today.cash)}
        note={today.deliveredCount === 0 ? t('aucun colis livré') : t('{n} colis livrés', { n: today.deliveredCount })} />
      <Cell label={t('Acomptes auj.')} value={formatDH(today.advances)}
        note={days != null ? t('{x} sur {n} j', { x: formatDH(today.advancesPeriod), n: days }) : t('{x} sur la période', { x: formatDH(today.advancesPeriod) })} />
      <Cell label={t('À encaisser')} value={formatDH(toCollect.amount)}
        title={toCollect.oldExcluded > 0 ? t('{n} commandes sans activité depuis 30 jours exclues', { n: toCollect.oldExcluded }) : undefined}
        note={`${t('{n} cmd', { n: toCollect.orders })}${toCollect.pendingPhotosAmount > 0 ? ` · ${t('+{x} en photos', { x: formatDH(toCollect.pendingPhotosAmount) })}` : ''}`} />
    </div>
  );
}

export function HomeCashCard({ data, isLoading, days, className = '' }: { data?: OverviewResponse; isLoading: boolean; days: number | null; className?: string }) {
  const { t } = useT();
  return (
    <HomeCard className={className}>
      <HomeCardTitle label={t('Caisse du jour')} />
      {isLoading ? <div aria-busy className="h-[64px] rounded-lg bg-adm-surface-3 animate-pulse" />
        : data ? <CashBody data={data} days={days} />
          : <p className="py-2 text-sm text-status-stuck">{t('Chiffres indisponibles — aucun chiffre plutôt qu’un chiffre faux.')}</p>}
    </HomeCard>
  );
}
